/**
 * TrustBadges — discreet trust signals shown on checkout and PDP (M215).
 * Linear icons + serif/uppercase typography to match the editorial aesthetic.
 */
import { ShieldCheck, RefreshCw, Sparkles, Star } from "lucide-react";

const BADGES = [
  { icon: ShieldCheck,
    text: "Certificado de Garantia e Nota Fiscal inclusos em toda compra" },
  { icon: RefreshCw,
    text: "7 dias de garantia para troca ou devolução" },
  { icon: Sparkles,
    text: "Há mais de 30 anos no mercado de joias" },
  { icon: Star,
    text: "10 anos de vendas online, com reputação nível verde no Mercado Livre" },
];

/**
 * variant="stack"   → vertical list (checkout sidebar)
 * variant="row"     → horizontal grid (PDP under product info)
 */
export default function TrustBadges({ variant = "stack", className = "" }) {
  const layout =
    variant === "row"
      ? "grid grid-cols-2 md:grid-cols-4 gap-x-6 gap-y-4"
      : "space-y-4";
  return (
    <div className={`${layout} ${className}`} data-testid="trust-badges">
      {BADGES.map(({ icon: Icon, text }, i) => (
        <div key={i} className="flex items-start gap-3" data-testid={`trust-badge-${i}`}>
          <span className="mt-0.5 text-[#B8A88A] shrink-0">
            <Icon size={16} strokeWidth={1.4} />
          </span>
          <p className="text-[12px] leading-relaxed text-[#4A4A4A]">{text}</p>
        </div>
      ))}
    </div>
  );
}
